module.exports = "/_next/static/images/31f2189046499005f0022bbf6cc62917-woman-with-yellow-glasses@0.75x.jpg.webp";